import React, { Component } from 'react';
import classes from './Auth.css';
import { connect } from 'react-redux';
import LoginForm from './LoginForm/LoginForm';
import SignupForm from './SignupForm/SignupForm';
import { Switch, Route, Redirect } from 'react-router-dom';
import * as actionCreators from '../../store/actions/index';
// import axios from '../../axios-orders';
// import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';

class Auth extends Component {

  render() {
    let authRedirect = null;

    if (this.props.token) {
      authRedirect = <Redirect to={this.props.redirectLocation} />
    }

    return (
      <div className={classes.Auth}>
        <Switch>
          {authRedirect}
          <Route path='/authenticate/login' render={() => {
            return <LoginForm submitCredentials={this.props.Authenticate} errorMessage={this.props.error} loading={this.props.loading} clearError={this.props.ClearAuthError} />
          }} />
          <Route path='/authenticate/signup' render={() => {
            return <SignupForm submitCredentials={this.props.Authenticate} errorMessage={this.props.error} loading={this.props.loading} clearError={this.props.ClearAuthError} />
          }} />
        </Switch>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    token: state.auth.token,
    error: state.auth.error,
    loading: state.auth.loading,
    redirectLocation: state.auth.redirectLocation
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    Authenticate: (email, password, type) => dispatch(actionCreators.authenticate(email, password, type)),
    ClearAuthError: () => dispatch(actionCreators.clearAuthError())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Auth);


// WEBPACK FOOTER //
// ./src/containers/Auth/Auth.jsx